import WindyImageLayer from './windy/WindyImageLayer';
import WindyImageLayerRenderer from './windy/WindyImageLayerRenderer';
import NwpSource from './nwp/NwpSource';
import NwpImageLayer from './nwp/NwpImageLayer';
import NwpImageLayerRenderer from './nwp/NwpImageLayerRenderer';
import NwpWindyLayer from './nwp/NwpWindyLayer';
import NwpWindyLayerRenderer from './nwp/NwpWindyLayerRenderer';
// import {create} from './windy/WindyWorker'
var windy = {};
windy.WindyImageLayer = WindyImageLayer;
windy.WindyImageLayerRenderer = WindyImageLayerRenderer;
// windy.WindyWorker = create;
var nwp = {};
nwp.NwpSource = NwpSource;
nwp.NwpImageLayer = NwpImageLayer;
nwp.NwpImageLayerRenderer = NwpImageLayerRenderer;
nwp.NwpWindyLayer = NwpWindyLayer;
nwp.NwpWindyLayerRenderer = NwpWindyLayerRenderer;
var kma = {};
kma.nwp = nwp;
kma.windy = windy;
export default kma;
//# sourceMappingURL=index.js.map